import 'jquery-lazy';
import { WEBP_FEATURES, isWebpFeatureSupported } from "../../../core/utils/utils";

export async function init(options) {
    const o = {
        sortBy: null,
        sortDir: null,
        shipFilter: null,
        commissionFilter: null,
        irAvailable: false,
        shops: [],
        canEdit: false,
        ...options
    };

    const isWebpSupported = await isWebpFeatureSupported(WEBP_FEATURES.LOSSY);
    if (!isWebpSupported) {
        o.shops.forEach(item => item.img = item.img.replace('.webp', '.png'));
    }

    const viewModel = new ViewModel(o);

    initCustomSelect();
    initShipFilter(viewModel);
    searchSubscribe(viewModel);

    ko.applyBindings(viewModel, $('#content')[0]);
}

function initCustomSelect() {
    $('.content-header').find('select[rel=chosen]').chosen();
}

function initShipFilter(viewModel) {
    $('.top-category-filter').change(function() {
        const $this = $(this);

        $this.parents('.filter-block').find('.category-filter').prop('checked', $this.prop('checked'));
        viewModel.update();
    });

    $('.category-filter').change(function() {
        viewModel.update();
    });
}

class ViewModel {
    shops = ko.observableArray([]);
    loading = ko.observable(false);
    nameFilter = ko.observable(null);
    _lazyLoader = null;

    constructor(options) {
        this.sortBy = ko.observable(options.sortBy);
        this._setStateMutableSubscription(this.sortBy);

        this.sortDir = ko.observable(options.sortDir);
        this._setStateMutableSubscription(this.sortDir);

        this.shipFilter = ko.observable(options.shipFilter);
        this._setStateMutableSubscription(this.shipFilter);

        this.commissionFilter = ko.observable(options.commissionFilter);
        this._setStateMutableSubscription(this.commissionFilter);

        this.nameFilter.subscribe(this._applyNameFilter, this);

        this.irAvailable = ko.observable(options.irAvailable);
        this._setStateMutableSubscription(this.irAvailable);

        this.canEdit = ko.observable(options.canEdit);

        this._setShops(options.shops);

        this.empty = ko.computed(() => this.shops().filter(shop => shop.satisfyFilter()).length === 0);

        this.checkedShops = ko.computed(() => this.shops().filter(shop => shop.checked()));

        const state = this._getState();
        if(window.history !== undefined) {
            window.history.replaceState(state, '');
            $(window).on('popstate', this._popState.bind(this));
        }
    }

    getShopPageUrl(shop) {
        return site_url(this.canEdit() ? `shops/edit/${shop.id}` : `shops/${shop.name_view}`);
    }

    generatePosts() {
        alert('Функция в стадии разработки');
    }

    update(observable = null) {
        const silent = (observable != null && observable.silentUpdating);
        if(silent) {
            observable.silentUpdating = false;
        } else {
            this._reload();
        }
    }

    _reload(state = null) {
        if(state == null) {
            state = this._getState();
            if(window.history !== undefined) {
                window.history.pushState(state, '', 'shops?' + $.param(state));
            }
        }

        this.shops.removeAll();
        this.loading(true);

        $.get(
            // Url of ajax request should differ from main page's url with filters (cache bug when using Chrome)
            site_url('shops/index'),
            state,
            (response) => {
                this.loading(false);
                if(response.success) {
                    this._setShops(response.shops);
                    this._applyNameFilter();

                    document.title = response.title;
                    $("meta[name='description']").attr('content', response.description);
                }
            },
            'json'
        );
    }

    _setShops(shops) {
        ko.utils.arrayPushAll(this.shops, shops.map(s => new ShopItem(s, this.canEdit())));

        setTimeout(() => {
            this._lazyLoader = $('.lazy-load').lazy({ chainable: false })
        });
    }

    _applyNameFilter() {
        const filter = this.nameFilter();
        if(filter) {
            this.shops().forEach(shop => shop.satisfyFilter(shop.name_view.search(new RegExp(filter, 'i')) != -1));
        } else {
            this.shops().forEach(shop => shop.satisfyFilter(true));
        }

        if (this._lazyLoader) {
            setTimeout(() => this._lazyLoader.update());
        }
    }

    _getState() {
        const categoriesFilter = [];
        const state = {
            sort_by: this.sortBy(),
            sort_dir: this.sortDir(),
            ship_filter: this.shipFilter(),
            commission_filter: this.commissionFilter(),
            c: categoriesFilter,
            v: 1 // Discard broken version og page in users' browsers
        };

        $('.category-filter').each(function(){
            const $this = $(this);
            if($this.prop('checked')) {
                categoriesFilter.push($this.val());
            }
        });

        if (this.irAvailable()) {
            state.ir_available = 1;
        }

        return state;
    }

    _setState(state) {
        this._setStateObservableSilently(this.sortBy, state.sort_by);
        this._setStateObservableSilently(this.sortDir, state.sort_dir);
        this._setStateObservableSilently(this.shipFilter, state.ship_filter);
        this._setStateObservableSilently(this.commissionFilter, state.comission_filter);
        this._setStateObservableSilently(this.irAvailable, !!state.ir_available);

        $(`.category-filter`).prop('checked', false);
        for(let i = 0; i < state.c.length; i++) {
            $(`.category-filter[value=${state.c[i]}]`).prop('checked', true);
        }

        setTimeout(() => $('.content-header').find('select[rel=chosen]').trigger('chosen:updated'), 200)
    }

    _popState(e) {
        if(e.originalEvent.state != null) {
            this._setState(e.originalEvent.state);
            this._reload(e.originalEvent.state);
        }
    }

    _setStateObservableSilently(observable, value) {
        observable.silentUpdating = true;
        observable(value);
    }

    _setStateMutableSubscription(observable) {
        observable.silentUpdating = false;
        observable.subscribe(() => this.update.call(this, observable));
    }

    changeSortDirASC(){
        this.sortDir('asc');
    }
    changeSortDirDESC(){
        this.sortDir('desc');
    }
}

class ShopItem {
    canEdit = false;
    hovered = ko.observable(false);
    satisfyFilter = ko.observable(true);
    checked = ko.observable(false);

    constructor(data, canEdit) {

        // copy all input keys directly to this instance
        for (const key in data) {
            if (data.hasOwnProperty(key)) {
                this[key] = data[key];
            }
        }

        this.canEdit = canEdit;
    }

    getShopPageUrl = () => {
        return site_url(this.canEdit ? `shops/edit/${this.id}` : `shops/${this.name_view}`);
    };

    handleMouseEnter = () => {
        this.hovered(true);
    };

    handleMouseLeave = () => {
        this.hovered(false);
    };
}

function searchSubscribe(viewModel){
    $('#name-filter').on('keyup keydown', function(){
        viewModel.nameFilter($(this).val());
    });
}

function hideShops(value){
    $('.shop-item').each(function(){
        if(value === 'all'){
            $(this).show();
        }
        else if($(this).attr('template') === value){
            $(this).show();
        }
        else{
            $(this).hide();
        }
    })
}

$('#filtertest').on('change', function(){
    const val = $(this).val();
    hideShops(val);
});







// WEBPACK FOOTER //
// ./modules/shops/list/index.js